module.exports = __webpack_public_path__ + "static/37-9f52c6eb0837a127a46334d4c1c7f067.jpg";